
import { Spacer as component } from '../../components/editor/Spacer'

export const Spacer = {
  label: 'Content Spacer',
  component,
  fields: [
    {
      name: 'amount',
      label: 'Amount',
      widget: 'string',
      default: '1',
      hint: 'Specify the ammount in rem. 1 ~= The height of a single line of text.'
    }
  ]
}
